import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Layout, Typography } from 'fronton-react';
import { cx } from 'linaria';
import { useSelector } from 'react-redux';
import { useBreakpoints } from 'common/hooks/use-breakpoints';
import { hideScrollbar } from 'common/styles';
import { patchUrlByLocale } from 'utils';
import { container, heading, projects } from './styles';
import { Project } from './project';
import { getStoreProjectsCenters } from '../store/ducks/get-store-by-id';

export const StoreProjects: FC = () => {
  const { t } = useTranslation();
  const projectCenters = useSelector(getStoreProjectsCenters);
  const { desktop, largeDesktop } = useBreakpoints() || { desktop: true };

  if (!projectCenters?.length) {
    return null;
  }
  // TODO: NAVI-3697
  return (
    <section className={container}>
      <Layout>
        <Typography variant="h3" className={heading}>
          {t('projectsCenters')}
        </Typography>
      </Layout>
      <div className={cx(projects, hideScrollbar)}>
        {projectCenters.map((project, idx) => (
          <Project
            dir={idx === 0 || !(desktop || largeDesktop) ? 'portrait' : 'landscape'}
            title={project.name}
            image={project.imgUrl}
            idx={idx}
            description={project.description}
            color={project.color}
            link={patchUrlByLocale(`${project.pagePath}`)}
            key={project.name}
          />
        ))}
      </div>
    </section>
  );
};
